import styles from '../styles/AuditReady.module.css';
import LoadingIndicator from './LoadingIndicator';
import { useQuery } from '@apollo/client';
import { LeadPollingQuery } from '../queries';
import { useRouter } from 'next/router';

type Props = {
  leadToken: string;
};

const AuditReady = ({ leadToken }: Props) => {
  const router = useRouter();
  const { error, stopPolling } = useQuery(LeadPollingQuery, {
    variables: {
      leadToken,
    },
    pollInterval: 500,
    notifyOnNetworkStatusChange: true,
    context: {
      headers: {
        ['X-RS-TOKEN']: leadToken,
        ['Access-Control-Allow-Credentials']: 'true',
      },
    },
    onCompleted: (data) => {
      if (data?.lead?.sources?.length) {
        stopPolling();
        router.push(`/audit-widget/report/${leadToken}`);
      }
    },
  });

  if (error) return <p>Error! ${error.message}</p>;

  return (
    <div className={styles.auditReady}>
      <h2>The brand audit report is being generated</h2>
      <LoadingIndicator className={styles.loadingIndicator} />
    </div>
  );
};

export default AuditReady;
